import { useFormik } from 'formik';
import { useContext, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Select from 'react-select';
import * as Yup from 'yup';

import { Hooks } from 'providers';
import { Organization } from 'providers/Organization';
import { useOuterClick } from 'providers/OutsideClick';

import { HIT_ADD_NODE_STRUCTURE } from 'redux/actions/organization';

import useOrgChart from 'components/_parts/molecules/Prompt/OrgChart/useOrgChart';
import { useTranslation } from 'react-i18next';

function ModalForm(props) {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const {
    pid__, tagAdd, modal, setModal, setPid__,
  } = useContext(Organization);
  const { setModal: setModal__, modal: modal__ } = useContext(Hooks);
  const { job_, loading } = useSelector((state) => ({
    job_: state.organization.list_job.map((val) => ({
      value: val.job_level_id,
      label: val.name,
    })),
    loading: state?.loading?.trigger,
  }));

  const innerRef = useOuterClick((e) => {
    if (e.srcElement.id === 'createNodesStructure') {
      setModal(false);
    }
  });
  const { fetchChart } = useOrgChart();
  const formik = useFormik({
    initialValues: {
      job_level_id: null,
      tag: null,
      report: '',
      name: '',
      job_grade: '',
      purpose: '',
    },
    validationSchema: Yup.object().shape({
      job_level_id: Yup.object()
        // .typeError("Must be string")
        .nullable()
        .required(t('org.employee.form.field_cannot_empty')),
      tag: Yup.object()
        // .typeError("Must be string")
        .nullable()
        .required(t('org.employee.form.field_cannot_empty')),
      //   report: Yup.string()
      //     .typeError("Must be string")
      //     .required("Field report to cannot empty"),
      name: Yup.string()
        .typeError('Must be string')
        .required(t('org.employee.form.field_cannot_empty')),
      job_grade: Yup.string()
        .typeError('Must be string')
        .required(t('org.employee.form.field_cannot_empty')),
    }),
    onSubmit: async (values, { resetForm }) => {
      await dispatch({
        type: HIT_ADD_NODE_STRUCTURE,
        payload: {
          // organization_id: newNode["Organization ID"],
          data: {
            job_grade: formik.values.job_grade,
            job_level_id: formik.values.job_level_id.value,
            report_to: pid__,
            purpose: formik.values.purpose,
            name: formik.values.name,
            tag: formik.values.tag.value,
          },
          organization_id: props?.organizationId,
        },
      });
      fetchChart.structure();
      setModal(false);
      setModal__(false);
      setPid__('random');
      formik.resetForm();
    },
  });

  useEffect(() => {
    formik.resetForm();
  }, [modal]);

  return (
    <div
      className={`modal fade rModal ${modal && 'show'}`}
      style={{
        width: 'fit-content',
        display: modal ? 'block !important' : 'none !important',
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
      }}
    >
      <div
        id="createNodesStructure"
        className="org-chart org-chart w-100 h-100 d-flex my-auto mx-auto"
      >
        <div className="org-chart_wrap my-auto mx-auto">
          <form id="fromAddNote" onSubmit={() => formik.handleSubmit()}>
            <h3>{props.title}</h3>
            <label>{t('org.job_lvl.name')}</label>
            {/* <input
                className="form-control form-control-md mb-2 "
                type="text"
                name="job_level_id"
                placeholder="Enter your name"
              /> */}
            <Select
              // styles={customStyles}
              options={job_}
              name="job_level_id"
              id="job_level_id"
              placeholder={t('org.structure_view.modal.select_job_lvl')}
              onChange={(e) => {
                formik.setFieldValue('job_level_id', e);
                // formik.setValues({
                //   ...formik.values,
                //   job_level_id: e
                // });
              }}
              value={formik.values.job_level_id}
            />
            {formik.touched.job_level_id && formik.errors.job_level_id ? (
              <>
                <span className="error">{formik.errors.job_level_id}</span>
                <br />
              </>
            ) : null}
            <label>{t('org.employee.position')}</label>
            <input
              className="form-control form-control-md mb-2 "
              type="text"
              name="name"
              value={formik.values.name}
              placeholder={t('org.component.enter_job_title')}
              onChange={formik.handleChange}
            />
            {formik.touched.name && formik.errors.name ? (
              <>
                <span className="error">{formik.errors.name}</span>
                <br />
              </>
            ) : null}
            <label>{t('org.component.tag')}</label>
            {/* <input
                className="form-control form-control-md mb-2 "
                type="text"
                name="tag"
                id="tag"
                value={formik.values.tag}
                onChange={formik.handleChange}
                placeholder="Enter your name"
              /> */}
            <Select
              // styles={customStyles}
              options={tagAdd}
              id="tag"
              name="tag"
              placeholder={t('org.component.select_tag')}
              onChange={(e) => {
                formik.setFieldValue('tag', e);
                // formik.setValues({
                //   ...formik.values,
                //   tag: e
                // });
              }}
              value={formik.values.tag}
            />
            {formik.touched.tag && formik.errors.tag ? (
              <>
                <span className="error">{formik.errors.tag}</span>
                <br />
              </>
            ) : null}
            <label>{t('org.index_view.form.job_grade')}</label>
            <input
              className="form-control form-control-md mb-2 "
              type="text"
              name="job_grade"
              onChange={formik.handleChange}
              value={formik.values.job_grade}
              placeholder={t('org.index_view.form.p_job_grade')}
            />
            {formik.touched.job_grade && formik.errors.job_grade ? (
              <>
                <span className="error">{formik.errors.job_grade}</span>
                <br />
              </>
            ) : null}
            <label>{t('org.index_view.form.purpose')}</label>
            <input
              className="form-control form-control-md mb-2 "
              type="text"
              name="purpose"
              onChange={formik.handleChange}
              value={formik.values.purpose}
              placeholder={t('org.index_view.form.p_purpose')}
            />
            <label>{t('org.index_view.report_to')}</label>
            <input
              className="form-control form-control-md mb-2 "
              type="text"
              name="report"
              value={pid__}
              defaultValue={pid__}
              disabled
              id="report"
              placeholder={t('org.employee.form.p_email')}
              onChange={formik.handleChange}
            />
            {formik.touched.report_to && formik.errors.report_to ? (
              <>
                <span className="error">{formik.errors.report_to}</span>
                <br />
              </>
            ) : null}

            <div className="btn-submit d-flex justify-content-center align-items-center float-right mt-4">
              <button
                className="add"
                type="button"
                onClick={(e) => {
                  formik.handleSubmit(e);
                }}
              >
                {t('board.submit')}
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
}

export default ModalForm;
